import { PAINT_OPT } from '../../constants/constants.jsx';

// Option Data for review details until conflicts implemented
export const selectedPVOptions  = (selectedOptions, selectedContract) => {
    return selectedOptions.map((option) => {
        const vendorData = option?.vendorValues?.find( vendor => vendor?.contractLineId === selectedContract?.contractLineId);
        if(vendorData) {
            return {
                ...option,
                optionQuantityRequired: option?.quantityRequiredCode,
                unitPrice: vendorData?.unitPrice ?? 0,
                quantity: option?.optionValue,
                optionType: vendorData?.unitPrice ? 'COST' : 'N/A',
                optionTotalPrice: parseFloat(vendorData?.unitPrice ?? 0) * parseInt(option?.optionValue ?? 1),
            }
        }else {
            return option;
        }
    });
}
export const getRequisitionVehiclePurchaseType = (account) => {
    const CONSOLIDATION_TYPES = ["REIMBIN", "NOREIMBIN"];

    if(account?.assetAcquisition) {
        return CONSOLIDATION_TYPES.includes(account?.assetAcquisition?.purchaseType) ? "CONSOLIDATION" : "REPLACEMENT";
    }else{
        return "ADDITIONAL";
    }
}

export const isRequisitionWithCustomPaintOptions = (selectedOptions, paintAndGraphicsDescription) => {
    let isRequisitionWithCustomPaintOption = false;
    let paintAndGraphicsOptions = structuredClone(paintAndGraphicsDescription) || [];
    for (const option of selectedOptions) {
        const inPaintAndGraphics = paintAndGraphicsOptions.find(
          (paintAndGraphicsOption) => {
              return paintAndGraphicsOption.optionCode === option.optionCode
          },
        );
        if(inPaintAndGraphics){
            isRequisitionWithCustomPaintOption = true;
        } else {
            if (option.optionCode === 'CPL' || option.optionCode === 'CPT' || option.tags.value.includes(PAINT_OPT)) {
                isRequisitionWithCustomPaintOption = true;
            }
        }
    }
    return isRequisitionWithCustomPaintOption;

}
export const updateLeasingSteps = (step, leasingSteps, index) => {
   return [
       ...leasingSteps.slice(0, index),
       step,
       ...leasingSteps.slice(index).map((step) => ({
           ...step,
           stepNumber: step.stepNumber + 1,
       })),
   ];
  };



export const getSelectedTaggedOptions = (selectedOptions, requiredTag) => {
    const results = [];
    selectedOptions?.forEach((opt) => {
        if (opt) {
                if (
                  opt.isChecked &&
                  opt.tags?.value &&
                  opt.tags.value.length > 0 &&
                  opt.tags.value.includes(requiredTag)
                ) {
                    results.push({
                        optionCategoryCode: opt.optionCategoryCode,
                        optionCategoryName: opt.optionCategoryName,
                        optionDescription: opt.optionDescription,
                        tags: opt.tags,
                    });
                }

        }
    });
    return results;
};